<template>
    <v-menu
        :offset-x="offsetX"
        :offset-y="offsetY"
        :nudge-top="nudgeTop"
        :right="right"
        :min-width="minWidth"
        :close-on-content-click="closeOnContentClick"
        :disabled="disabled">
        <template v-slot:activator="{ on, attrs }">
            <slot name="activator" :on="on" :attrs="attrs" :disabled="disabled"></slot>
        </template>
        <v-list dense nav>
            <v-list-item
                v-for="spaceTypeKey in spaceTypeOrder"
                :key="`space-create-menu-${spaceTypeKey}`"
                :disabled="disabled"
                @click="selectSpaceType(spaceTypeKey)">
                <v-list-item-icon>
                    <v-icon :class="spaceTypeMetaByKey(spaceTypeKey).iconColorClass">
                        {{ spaceTypeMetaByKey(spaceTypeKey).icon }}
                    </v-icon>
                </v-list-item-icon>
                <v-list-item-title :class="spaceTypeMetaByKey(spaceTypeKey).iconColorClass" class="mr-5">
                    {{ spaceTypeMetaByKey(spaceTypeKey).label }}
                </v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
import { SPACE_TYPE_ORDER } from '@/utils/spaceTypeMeta'
import spaceTypeUi from '@/mixins/spaceTypeUi'

export default {
    name: 'SpaceCreateMenu',
    mixins: [spaceTypeUi],
    props: {
        closeOnContentClick: {
            type: Boolean,
            default: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        minWidth: {
            type: [Number, String],
            default: undefined
        },
        nudgeTop: {
            type: [Number, String],
            default: undefined
        },
        offsetX: {
            type: Boolean,
            default: false
        },
        offsetY: {
            type: Boolean,
            default: false
        },
        right: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        spaceTypeOrder() {
            return SPACE_TYPE_ORDER
        }
    },
    methods: {
        selectSpaceType(spaceTypeKey) {
            const createType = this.spaceTypeMetaByKey(spaceTypeKey).createType
            if (createType) {
                this.$emit('select', createType)
            }
        }
    }
}
</script>
